import i18n from "@/i18n"
import { loadLocaleMessages } from "./loadLocalMessages";

const supportedLocales = [
  { code: 'no', label: 'Norsk', flag: '/flags/no-4x3.svg' },
  { code: 'en', label: 'English', flag: '/flags/gb-4x3.svg' }
];

const Trans = {
  get defaultLocale() {
    return import.meta.env.VITE_DEFAULT_LOCALE
  },

  get supportedLocales() {
    return supportedLocales;
  },

  get currentLocale() {
    return i18n.global.locale.value
  },

  set currentLocale(newLocale) {
    i18n.global.locale.value = newLocale
  },

  async switchLanguage(newLocale: string) {
    const messages = await loadLocaleMessages(newLocale);
    i18n.global.setLocaleMessage(newLocale, messages);
    i18n.global.locale.value = newLocale;

    localStorage.setItem("user-locale", newLocale)
  },

  isLocaleSupported(locale: string) {
    return Trans.supportedLocales.some(supportedLocale => supportedLocale.code === locale);
  },

  getUserLocale() {
    const locale = window.navigator.language ||
      Trans.defaultLocale

    return {
      locale: locale,
      localeNoRegion: locale.split('-')[0]
    }
  },

  getPersistedLocale() {
    const persistedLocale = localStorage.getItem("user-locale") || ""

    if(Trans.isLocaleSupported(persistedLocale)) {
      return persistedLocale
    } else {
      return null
    }
  },

  async guessDefaultLocale() {
    const userPersistedLocale = Trans.getPersistedLocale()
    if(userPersistedLocale) {
      return userPersistedLocale
    }

    const userPreferredLocale = Trans.getUserLocale()

    if (Trans.isLocaleSupported(userPreferredLocale.locale)) {
      return userPreferredLocale.locale
    }

    if (Trans.isLocaleSupported(userPreferredLocale.localeNoRegion)) {
      return userPreferredLocale.localeNoRegion
    }

    return Trans.defaultLocale
  },
}

export default Trans
